/**
 * @generated SignedSource<<07898bac791e2f1ce9dccbbf01baecb4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PermissionEnum = "ai_correct_probability_test_read" | "ai_top_percent_test_read" | "app_dialog_create" | "app_dialog_delete" | "app_dialog_read" | "app_dialog_update" | "app_push_create" | "app_push_delete" | "app_push_read" | "assigned_task_read" | "bill_admin" | "bill_create" | "bill_delete" | "bill_read" | "bill_update" | "book_create" | "book_delete" | "book_read" | "book_scrap_create" | "book_scrap_delete" | "book_scrap_update" | "book_update" | "codepush_version_read" | "codepush_version_update" | "comment_create" | "comment_delete" | "comment_read" | "comment_update" | "delivery_order_cancel" | "delivery_order_complete" | "delivery_order_create" | "delivery_order_read" | "delivery_order_update" | "delivery_order_xlsx_export" | "delivery_order_xlsx_import" | "error_report_delete" | "error_report_read" | "formula_set_read" | "formula_set_review" | "formula_set_update" | "generated_problem_activate" | "generated_problem_deactivate" | "generated_problem_read" | "generated_problems_create" | "group_create" | "group_delete" | "group_read" | "group_update" | "math_king_user_read" | "math_king_user_update" | "my_organization_read" | "notice_create" | "notice_delete" | "notice_read" | "notice_update" | "organization_create" | "organization_invoice_create" | "organization_read" | "organization_sms_send" | "organization_user_create" | "permission_setting_read" | "premium_apply_history_upsert" | "problem_charge_event_create" | "problem_charge_event_delete" | "problem_charge_event_read" | "problem_charge_event_update" | "problem_generator_activate" | "problem_generator_assign" | "problem_generator_deactivate" | "problem_generator_publish" | "problem_generator_read" | "product_activate" | "product_create" | "product_deactivate" | "product_delete" | "product_event_create" | "product_event_delete" | "product_event_read" | "product_event_update" | "product_read" | "product_update" | "promotion_activate" | "promotion_create" | "promotion_deactivate" | "promotion_delete" | "promotion_read" | "promotion_update" | "quiz_create" | "quiz_delete" | "quiz_read" | "quiz_review" | "quiz_set_labeling" | "quiz_set_read" | "quiz_update" | "raffle_create" | "raffle_delete" | "raffle_read" | "raffle_stuff_create" | "raffle_stuff_delete" | "raffle_stuff_read" | "raffle_stuff_update" | "raffle_update" | "school_exam_problem_approve" | "school_exam_problem_delete" | "school_exam_problem_read" | "school_exam_problem_reject" | "school_exam_scrap_create" | "school_exam_scrap_delete" | "school_exam_scrap_update" | "school_exam_source_assign" | "school_exam_source_export_image" | "school_exam_source_inner_pdf_delete" | "school_exam_source_inner_pdf_upload" | "school_exam_source_publish" | "school_exam_source_read" | "school_read" | "scrap_create" | "scrap_delete" | "scrap_read" | "scrap_source_create" | "scrap_source_delete" | "scrap_source_read" | "scrap_source_submit" | "scrap_source_undo_submit" | "scrap_source_update" | "store_stuff_create" | "store_stuff_delete" | "store_stuff_read" | "store_stuff_update" | "stuff_create" | "stuff_delete" | "stuff_read" | "stuff_update" | "task_create" | "task_delete" | "task_hint_feedback_publish" | "task_hint_feedback_save" | "task_problem_assign" | "task_problem_creation" | "task_problem_image_creation" | "task_problem_labeling" | "task_problem_publish" | "task_problem_typing" | "task_read" | "task_solution_video_create" | "task_solution_video_delete" | "task_solution_video_read" | "task_solution_video_update" | "task_update" | "task_video_create" | "task_video_delete" | "task_video_read" | "task_video_update" | "typing_automation_history_create" | "typing_automation_script_read" | "unit_read" | "user_delete" | "user_read" | "user_update" | "virtual_solved_problem_create" | "virtual_solved_problem_delete" | "virtual_solved_problem_read" | "virtual_solved_problem_update" | "virtual_user_create" | "virtual_user_delete" | "virtual_user_read" | "virtual_user_update" | "workbook_category_create" | "workbook_category_delete" | "workbook_category_read" | "workbook_category_update" | "workbook_create" | "workbook_delete" | "workbook_publish" | "workbook_read" | "workbook_tasks_add" | "workbook_tasks_delete" | "workbook_tasks_reorder" | "workbook_update" | "%future added value";
export type PermissionRoute_meQuery$variables = {};
export type PermissionRoute_meQuery$data = {
  readonly me: {
    readonly email: string;
    readonly id: string;
    readonly name: string;
    readonly permissions: ReadonlyArray<{
      readonly id: string;
      readonly title: PermissionEnum;
    }>;
  };
};
export type PermissionRoute_meQuery = {
  response: PermissionRoute_meQuery$data;
  variables: PermissionRoute_meQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Permission",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PermissionRoute_meQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PermissionRoute_meQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "65eeb568154811b05c694debca14f3f1",
    "id": null,
    "metadata": {},
    "name": "PermissionRoute_meQuery",
    "operationKind": "query",
    "text": "query PermissionRoute_meQuery {\n  me {\n    id\n    name\n    email\n    permissions {\n      id\n      title\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c41bcc847e7011a5d94d9b471d880a0c";

export default node;
